<template>
  <div>
    <el-form-item label="Environment">
      <el-select v-model="form.env" @change="change">
        <el-option value="development" label="Development" />
        <el-option value="staging" label="Staging" />
        <el-option value="production" label="Production" />
      </el-select>
    </el-form-item>

    <el-form-item label="Database">
      <el-select v-model="form.db" @change="change">
        <el-option :value="null" label="None" />
        <el-option value="mysql:5.7" label="MySQL 5.7 (embedded)" />
      </el-select>

      <el-button
        v-if="form.db"
        icon="mdi mdi-open-in-new"
        @click.prevent="dbadmin"
      >
        phpMyAdmin
      </el-button>
    </el-form-item>
  </div>
</template>

<script>
import config from '../../../mixins/config'
export default {
  mixins: [config],
  methods: {
    dbadmin () {
      window.open(this.applicationUrl(this.form) + '/runstack-dbadmin/', '_blank')
    }
  }
}
</script>
